import { render, staticRenderFns } from "./SaleChanceDetails.vue?vue&type=template&id=363eb094"
import script from "./SaleChanceDetails.vue?vue&type=script&lang=js"
export * from "./SaleChanceDetails.vue?vue&type=script&lang=js"
import style0 from "./SaleChanceDetails.vue?vue&type=style&index=0&id=363eb094&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports